<template>
  <div class="prcie_ep">
    <Menu />
    <div class="cont">
      <pricingTop type="ep" />
      <div class="tabs">
        <router-link class="titem titem1" to="/pricing_individual.html">个人专属</router-link>
        <router-link class="titem titem0" to="/pricing_enterprise.html"
          >企业专属</router-link
        >
        <router-link class="titem titem1" to="/pricing_desktron.html">云桌面</router-link>
      </div>
      <!-- 企业-标准版 -->
      <div class="high_bx bz_bx">
        <div class="top_line"></div>
        <div class="title_bx">
          <p>标准版</p>
        </div>
        <p class="desc0">
          适用于远程办公、项目开发、连接<br />虚拟机、访问业务专机
        </p>
        <div class="price_bx">
          <p class="t1">¥</p>
          <p class="t2">805</p>
          <p class="t3">元/用户/年</p>
          <p class="t4"></p>
        </div>
        <div class="pricedesc">
          <p>
            100人以上请<span class="uline" @click="getService"
              >咨询客服</span
            >
          </p>
          <p>获取最优组合</p>
        </div>
        <a href="https://console.todesk.com/#/register" class="to_btn"
          >免费试用</a
        >
        <div class="desc_items">
          <p>
            <img src="@/assets/pricing2/ep/bzcheck@2x.png" alt="" /><span
              >专属高速线路,带宽优先保障</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/bzcheck@2x.png" alt="" /><span
              >20多项通用办公能力</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/bzcheck@2x.png" alt="" /><span
              >30多项安全功能与管理功能</span
            >
          </p>
        </div>
        <router-link to="/pricing/enterprisedetail?tab=0" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/ep/angle@2x.png" alt="" />
        </router-link>
      </div>
      <!-- 企业-高性能设计 -->
      <div class="high_bx gxn_bx">
        <div class="title_bx">
          <p>高性能设计</p>
        </div>
        <p class="desc0">
          适用于设计制图、建模渲染、游戏<br />开发、视频剪辑等场景
        </p>
        <div class="price_bx">
          <p class="t1">¥</p>
          <p class="t2">1550</p>
          <p class="t3">元/用户/年</p>
          <p class="t4"></p>
        </div>
        <div class="pricedesc">
          <p>
            100人以上请<span class="uline" @click="getService"
              >咨询客服</span
            >
          </p>
          <p>获取最优组合</p>
        </div>
        <a href="https://console.todesk.com/#/register" class="to_btn">免费试用</a>
        <div class="desc_items">
          <p>
            <img src="@/assets/pricing2/ep/gxcheck@2x.png" alt="" /><span
              >涵盖标准版全部功能</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/gxcheck@2x.png" alt="" /><span
              >支持4K60FPS</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/gxcheck@2x.png" alt="" /><span
              >端到端延时低至40ms</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/gxcheck@2x.png" alt="" /><span
              >鼠标加速最高可达120hz</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/gxcheck@2x.png" alt="" /><span
              >丰富外接设备支持</span
            >
          </p>
        </div>
        <router-link to="/pricing/enterprisedetail?tab=1" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/ep/angle@2x.png" alt="" />
        </router-link>
      </div>
      <!-- 企业-技术支持 -->
      <div class="high_bx jszc_bx">
        <div class="title_bx">
          <p>技术支持</p>
        </div>
        <p class="desc0">
          适用于客户技术支持、公司IT管理、<br />无人值守等场景
        </p>
        <div class="price_bx">
          <p class="t1">¥</p>
          <p class="t2">3096</p>
          <p class="t3">/通道/年</p>
          <p class="t4"></p>
        </div>
        <div class="pricedesc">
          <p>
            100人以上请<span class="uline" @click="getService">咨询客服</span>
          </p>
          <p>获取最优组合</p>
        </div>
        <a href="https://console.todesk.com/#/register" class="to_btn">免费试用</a>
        <div class="desc_items">
          <p>
            <img src="@/assets/pricing2/ep/jscheck@2x.png" alt="" /><span
              >涵盖标准版全部功能*</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/jscheck@2x.png" alt="" /><span
              >控制各类安卓设备</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/jscheck@2x.png" alt="" /><span
              >工单队列申请协助</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/jscheck@2x.png" alt="" /><span
              >SOS客户免安装</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/jscheck@2x.png" alt="" /><span
              >企业版主控端连接个人版设备</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/jscheck@2x.png" alt="" /><span
              >web远控个人版设备</span
            >
          </p>
        </div>
        <router-link to="/pricing/enterprisedetail?tab=2" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/ep/angle@2x.png" alt="" />
        </router-link>
      </div>
      <!-- 私有化部署 -->
      <div class="high_bx syh_bx">
        <div class="title_bx">
          <p>私有化部署</p>
        </div>
        <p class="desc0">灵活定制本地部署方案</p>
        <div class="desc_items">
          <p>
            <img src="@/assets/pricing2/ep/sycheck@2x.png" alt="" /><span
              >本地服务器部署</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/sycheck@2x.png" alt="" /><span
              >数据自主掌控</span
            >
          </p>
          <p>
            <img src="@/assets/pricing2/ep/sycheck@2x.png" alt="" /><span
              >多种传输方案兼顾安全与性能</span
            >
          </p>
        </div>
        <a href="https://enterprise.todesk.com/contact" class="to_btn"
          >咨询客户经理</a
        >
        <p class="line"></p>
        <div class="desc_item">
          <span class="t1"
            >· 按照公司规模和业务需要<br />&nbsp;&nbsp;灵活搭配账户类型和功能套餐</span
          >
        </div>
        <div class="desc_item">
          <span class="t1"
            >· 多种线路方案可选，私有化部署<br />&nbsp;&nbsp;也可享受企业级SD-WAN
            网络服务</span
          >
        </div>
        <div class="desc_item">
          <span class="t1"
            >· VIP专属团队全程服务：<br />&nbsp;&nbsp;解决方案专家、项目实施专家、<br />&nbsp;&nbsp;技术支持专家为您提供全流程全方位支持</span
          >
        </div>
        <div class="desc_item">
          <span class="t1"
            >· 按需定制更多安全功能<br />&nbsp;&nbsp;满足各行业合规要求</span
          >
        </div>
        <div class="desc_item">
          <span class="t1"
            >· 胜任大型组织、多分支、多厂区场景<br />&nbsp;&nbsp;支持10万级设备和人员的结构化管理</span
          >
        </div>
        <router-link to="/pricing/enterprisedetail?tab=3" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/ep/angle@2x.png" alt="" />
        </router-link>
      </div>
      <div class="container">
        <p class="explain">*技术支持套餐不支持扩展虚拟屏功能</p>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import pricingTop from "@/components/pricingTop";
export default {
  components: {
    Menu,
    Footer,
    pricingTop,
  },
  data() {
    return {
      pugin_list: [
        {
          title: "多通道能力",
          icon: "tongdao@2x.png",
          desc: ["多主控同时发起远控", "最多不能购买超过5通道"],
          price: "89.9",
        },
        {
          title: "免root控制安卓",
          icon: "mroot@2x.png",
          desc: ["开启辅助权限控制安卓设备", "移动端设备也可以控制安卓"],
          price: "7.9",
        },
        {
          title: "全球网络节点",
          icon: "gjiedian@2x.png",
          desc: ["遍布全球范围的众多节点", "超低延时，轻松打通地域限制"],
          price: "49.9",
        },
      ],
      qs_list: [
        {
          id: 1,
          title: "是否开具发票",
          type: 0,
        },
        {
          id: 2,
          title:
            "Windows 云服务器无法卸载云硬盘,Windows 云服务器无法卸载云硬盘",
          type: 1,
        },
        {
          id: 1,
          title: "是否可以申请合同",
          type: 0,
        },
      ],
    };
  },
  methods: {
    getService() {
      window.location.href = "https://enterprise.todesk.com/contact";
    },
  },
};
</script>
<style lang="less" scoped>
.prcie_ep {
  background: #fff;
  .cont {
    padding-bottom: 24px;
    background: url("~@/assets/pricing/pricing_bg@3x.png") no-repeat;
    background-size: 100% auto;
    background-repeat: no-repeat;
    .tabs {
      width: fit-content;
      height: 50px;
      background: #FFFFFF;
      border-radius: 25px;
      padding: 4px;
      box-sizing: border-box;
      margin: auto;
      margin-top: 32px;
      box-shadow: 0 3px 6px rgba(0,0,0,.05);
      .titem {
        width: 106px;
        height: 42px;
        border-radius: 21px;
        display: inline-block;
        text-align: center;
        line-height: 42px;
      }
      .titem0 {
        background: #37B3FC;
        box-shadow: 0px 2px 4px 0px rgba(0, 68, 152, 0.18);
        color: #131314;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      .titem1 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
    }
    .high_bx {
      width: 327px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      text-align: center;
      margin: auto;
      margin-top: 24px;
      padding-bottom: 24px;
      box-sizing: border-box;
      position: relative;
      padding-top: 40px;
      .top_line {
        position: absolute;
        left: -1px;
        top: -1px;
        width: calc(100% + 0.5px);
        height: 8px;
        border-radius: 4px 4px 0 0;
      }
      .title_bx p {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #272727;
        margin-left: 4px;
      }
      .desc0 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #83888f;
        margin-top: 9px;
      }
      .price_bx {
        margin-top: 22px;
        display: flex;
        justify-content: center;
        align-items: baseline;
      }
      .price_bx .t1 {
        font-size: 16px;
        font-family: Barlow-Medium, Barlow;
        font-weight: 500;
        color: #000;
        margin-right: 2px;
      }
      .price_bx .t2 {
        font-size: 40px;
        font-family: Barlow-SemiBold, Barlow;
        font-weight: 600;
        color: #000;
      }
      .price_bx .t3 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000;
        margin-left: 2px;
      }
      .price_bx .t4 {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #88898d;
        margin-left: 2px;
      }
      .pricedesc {
        margin-top: 18px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #88898d;
        line-height: 20px;
        margin-bottom: 42px;
      }
      .pricedesc .uline {
        color: #0070F9;
        &:active {
          opacity: 0.8;
        }
      }
      .price_add {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #88898d;
        text-align: left;
        padding-left: 39px;
      }
      .desc_items p {
        padding-left: 39px;
        display: flex;
        align-items: center;
        margin-top: 18px;
      }
      .desc_items p img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
      .desc_items p span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #272727;
      }
      .to_btn {
        display: block;
        margin: auto;
        margin-top: 24px;
        width: 210px;
        height: 50px;
        background: #1d64d0;
        border-radius: 4px;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        &:active {
          background: #0077e6;
        }
      }
      .line {
        width: 100%;
        height: 0;
        border-bottom: 1px solid #ebedf0;
        margin-top: 32px;
      }
      .desc_item {
        text-align: left;
        margin-top: 20px;
        padding-left: 20px;
        padding-right: 10px;
      }
      .desc_item .t1 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
      .desc_full {
        margin-top: 23px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:active {
          opacity: 0.8;
        }
      }
      .desc_full span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0070f9;
      }
      .desc_full img {
        margin-left: 4px;
        width: 12px;
      }
    }

    .bz_bx {
      .top_line {
        background: #38c0ff;
      }
      // border-top: 8px solid #38C0FF;
    }
    .gxn_bx {
      border-top: 8px solid #1d64d0;
    }
    .jszc_bx {
      border-top: 8px solid #30d1aa;
    }
    .syh_bx {
      border-top: 8px solid #FFBD33;
      .to_btn {
        width: 210px;
      }
      .desc0 {
        margin-bottom: 40px;
      }
      .desc_item {
        padding-left: 14px;
      }
    }
  }
  .container {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
    margin-right: 24px;
    .explain {
      align-self: flex-end;
      font-weight: 400;
      color: #272727;
    }
  }
}
</style>
